import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "../ui/CtaButton";
import { comparison } from "../../data/content";
export function FinalCta() {
  return <section className="bg-forest py-16 text-ivory md:py-24" data-id="element-56" data-mp="1np9cul1hkh86">
      <div className="mx-auto max-w-wrap px-5 md:px-8" data-id="element-57" data-mp="1nopyfeb1oayw">
        <h2 className="heading mx-auto max-w-[860px] text-center text-[42px] md:text-[68px]" data-id="element-58" data-mp="1snawp86qkkkp">
          Your next bag <span className="text-sand" data-id="element-59" data-mp="1en8grrhzo183">is already mapped out.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-[600px] text-center text-[17px] text-ivory/85" data-id="element-60" data-mp="1iqent1cxdwfm">
          Ten bags to make, cutting tables in inches and metric, and five bonuses for everything around the sewing.
        </p>

        <div className="mx-auto mt-10 grid max-w-[920px] gap-4 md:mt-14 md:grid-cols-2" data-id="element-61" data-mp="19q9pdgppm8dl">
          <div className="rounded-2xl border border-white/15 bg-forest-deep p-6 md:p-7" data-id="element-62" data-mp="2z3vctfkjfxyc">
            <h3 className="font-display text-2xl font-bold uppercase text-ivory/70" data-id="element-63" data-mp="343re371upba7">Without Bagmaking Ready</h3>
            <ul className="mt-5 space-y-3.5" data-id="element-64" data-mp="2837qszk3kpc">
              {comparison.map(c => <li key={c.without} className="flex items-start gap-3 text-[15px] text-ivory/75" data-id="element-65" data-mp="3tg7nmrpc2bzr">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#E3A08A]" aria-hidden="true" data-id="element-66" data-mp="b1omwdfmv3za" />
                  {c.without}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-sand bg-cream p-6 text-charcoal md:p-7" data-id="element-67" data-mp="3ff500aiowtmq">
            <h3 className="font-display text-2xl font-bold uppercase text-forest" data-id="element-68" data-mp="3ah3frm9j2o9o">With Bagmaking Ready</h3>
            <ul className="mt-5 space-y-3.5" data-id="element-69" data-mp="3oglaei9i8vqy">
              {comparison.map(c => <li key={c.with} className="flex items-start gap-3 text-[15px] font-medium" data-id="element-70" data-mp="3jhi6j159gvkk">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-forest" aria-hidden="true" data-id="element-71" data-mp="13pu9z6u5t52a" />
                  {c.with}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex justify-center" data-id="element-72" data-mp="3sjind7qb8yyh">
          <CtaButton href="#offer-details" data-id="element-73" data-mp="3sippyxd8rlt0">Start Making Bags</CtaButton>
        </div>
      </div>
    </section>;
}